import React from "react";

type IconProps = {
  className?: string;
  name?: IconTypes | string;
  disabled?: boolean;
};

export type IconTypes =
  | "question"
  | "user-profile"
  | "payment"
  | "payment2"
  | "portal-attach"
  | "exit"
  | "folder"
  | "sort"
  | "internet"
  | "link"
  | "mobile"
  | "turn-off"
  | "refresh"
  | "save"
  | "share"
  | "shop"
  | "trash"
  | "calender"
  | "fax"
  | "bottom-arrow"
  | "left-arrow"
  | "right-arrow"
  | "top-arrow"
  | "key"
  | "message-box"
  | "pencil"
  | "setting"
  | "star"
  | "factor"
  | "tickets"
  | "view"
  | "renew"
  | "attach"
  | "download"
  | "user"
  | "paste"
  | "home"
  | "chart"
  | "location"
  | "bar-chart"
  | "view-ticket"
  | "copy"
  | "headset"
  | "thinking"
  | "list"
  | "services"
  | "faq"
  | "refresh1"
  | "history"
  | "calculator"
  | "speed"
  | "ticketing"
  | "comment-tick"
  | "portalicons-tozihat"
  | "status"
  | "wifi"
  | "time"
  | "phone"
  | "phone-ringing"
  | "zitel-logo"
  | "paid"
  | "deposits-list"
  | "pay-chart"
  | "wallet"
  | "return-invoice"
  | "receipts"
  | "receipts-pay"
  | "financial-chart"
  | "pulse"
  | "repeat"
  | "graph"
  | "folder-open"
  | "cloud-upload"
  | "notepad"
  | "time-speed"
  | "hourglass"
  | "repeat-2"
  | "cloud-computing"
  | "inbox"
  | "open-folder-outline"
  | "speed-fast"
  | "speed-simple"
  | "speed-arrow"
  | "timer-speed"
  | "search"
  | "complaint"
  | "upgrade"
  | "bell"
  | "crown";

const Icon: React.FC<IconProps> = (props) => {
  const { name, className, disabled = false } = props;

  return <span className={`icon-${name} ${disabled ? "disabledIcon" : null} ${className}`} />;
};

export default Icon;
